<template>
  <div class="conversion-block">
    <component :is="campaign" :colorMode="colorMode"></component>
  </div>
</template>

<script>
import marketMapConversion from 'components/blok/conversion/market-map-conversion'
import solutionsConversion from 'components/blok/conversion/solutions-conversion'
import investorIntelligenceConversion from 'components/blok/conversion/investor-intelligence'
import investorDealOriginationConversion from 'components/blok/conversion/investor-deal-origination'
import bankRelationshipOnboardingConversion from 'components/blok/conversion/bank-relationship-onboarding'
import bankerCoverageConversion from 'components/blok/conversion/banker-coverage'
import investorResearchConversion from 'components/blok/conversion/investor-research'
import mncsDistributionTeamConversion from 'components/blok/conversion/mncs-distribution-team'
import mncsProcurementTeamConversion from 'components/blok/conversion/mncs-procurement-team'
import riskAdvisorTeamsConversion from 'components/blok/conversion/risk-advisor-teams'
import sourceCompanyConversion from 'components/blok/conversion/source-company'
import undpPromo from 'components/blok/conversion/undp-conversion'
import proposalsPromo from 'components/blok/conversion/proposals-promo'
// promos 2023
import commercialBroad from 'components/blok/conversion-2023/commercial-broad'
import corpDocs from 'components/blok/conversion-2023/corp-docs'
import deInvestors from 'components/blok/conversion-2023/de-investors'
import deTdb from 'components/blok/conversion-2023/de-tdb'
import ethicsFirst from 'components/blok/conversion-2023/ethics-first'
import financingOpportunities from 'components/blok/conversion-2023/financing-opportunities'
import futureInterest from 'components/blok/conversion-2023/future-interest'
import impactOriented from 'components/blok/conversion-2023/impact-oriented'

import blokOptions from 'src/data/blok-options'

export default {
  name: 'blok-conversion',
  components: {
    marketMapConversion,
    solutionsConversion,
    investorIntelligenceConversion,
    investorDealOriginationConversion,
    bankRelationshipOnboardingConversion,
    bankerCoverageConversion,
    investorResearchConversion,
    mncsDistributionTeamConversion,
    mncsProcurementTeamConversion,
    riskAdvisorTeamsConversion,
    sourceCompanyConversion,
    undpPromo,
    proposalsPromo,
    // 2023
    commercialBroad,
    corpDocs,
    deInvestors,
    deTdb,
    ethicsFirst,
    financingOpportunities,
    futureInterest,
    impactOriented
  },
  props: ['blok'],
  computed: {
    campaign() {
      let campaign = 'marketMapConversion'
      const outdatedMap = {
        marketMapConversion: "commercialBroad",
        solutionsConversion: "commercialBroad",
        bankerCoverageConversion: "commercialBroad",
        mncsDistributionTeamConversion: "commercialBroad",
        investorResearchConversion: "commercialBroad",
        investorIntelligenceConversion: "deInvestors",
        investorDealOriginationConversion: "deInvestors",
        bankRelationshipOnboardingConversion: "ethicsFirst",
        mncsProcurementTeamConversion: "ethicsFirst",
        riskAdvisorTeamsConversion: "corpDocs",
        sourceCompanyConversion: "financingOpportunities",
        undpPromo: "impactOriented",
        proposalsPromo: "deTdb"
      }
      if (blokOptions.conversionCampaigns.includes(this.blok.campaign)) {
        campaign = this.blok.campaign
      }
      if (outdatedMap[campaign]) {
        campaign = outdatedMap[campaign]
      }
      return campaign
    },
    colorMode() {
      const mode = _.get(this.blok, 'color_mode')
      return mode || 'light'
    },
  },
}
</script>

<style lang="scss">
.conversion-block {
  .main-container {
    padding: 20px;
    background-color: #f9fbfd;
    color: #777e85;
    border: 2px solid #e3e9ef;
    border-radius: 5px;
    h2 {
      margin: 0px;
      padding: 0px;
      margin-bottom: 10px;
      font-weight: 600;
      text-align: center;
      color: #002560;
      font-weight: bold;
    }
  }
  .action-wrap {
    text-align: center;
  }
}
.conversion-block {
  .dark-block {
    padding: 20px;
    background-color: $primary-bg;
    color: #fff;
    border: 2px solid $primary-border;
    h2 {
      margin: 0px;
      padding: 0px;
      margin-bottom: 10px;
      font-weight: 600;
      text-align: center;
      color: $primary-accent-color;
      font-weight: bold;
    }
  }
}
</style>
